export default __webpack_public_path__ + "static/media/about-header_1-1536x489.923e8e0a.jpg";